import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, initialized } = useAuth();
  if (!initialized) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F7F5F0]">
        <div className="text-sm text-[#8A847A]">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
